import React from 'react'
import {Route, useHistory, useLocation} from 'react-router-dom'
import {CSSTransition} from 'react-transition-group'
import store, {useDomainsList, useFormValues, useTransitions, useFacebookConnect, useFormError} from './store'
import ErrorBoundary from "@formComponentsHome/ErrorBoundary"
import {useTranslation} from "react-i18next"
// pages
import Step1 from '@formStepsHome/Step1'
import Spinner from "./components/Spinner";

const routes = [
  { path: '/', name: 'index', Component: Step1 },
  { path: '/step-1', name: 'step-1', Component: Step1 },
];

export default () => {
  const {t} = useTranslation();
  const Store = store.Provider;
  const domainsList = useDomainsList();
  const formValues = useFormValues();
  const transitions = useTransitions();
  const fbConnectWidget = useFacebookConnect();
  const formErrors = useFormError();

  const history = useHistory();
  React.useEffect(() => {
    history.listen(({ pathname }) => {
      dataLayer.push({
        event: 'change_page',
        vpvname: routes.find(({ path }) => path === pathname)?.name,
      });
    });
  }, []);

  return (
    <ErrorBoundary>
    <Store value={{
      domainsList: domainsList,
      formValues: formValues,
      transitions: transitions,
      fbConnectWidget: fbConnectWidget,
      formErrors: formErrors
    }}>
      {routes.map(({ path, Component }) => (
        <Route key={path} exact path={path}>
          {props => (
            <CSSTransition
              in={props.match != null}
              timeout={300}
              classNames={transitions.current}
              unmountOnExit
            >
                <Component />
            </CSSTransition>
          )}
        </Route>
      ))}
    </Store>
    </ErrorBoundary>
  )
}